// extracted by mini-css-extract-plugin
export default {"topNavigation":"kU2es5","container":"LnLd_R","categoriesContainer":"d3XSOo","link":"UlUPo4","linkAccessibility":"ckIWcX"};